import { ClipboardList, ListChecks } from 'lucide-react'
import { SurveysSpaceFields } from '@/components/features/surveys/SurveysSpaceFields'
import { defaultSurveysConfig, surveysConfigApiErrors, surveysConfigOf } from '@/components/features/surveys/surveysSpaceConfig'
import { sdk } from '@/lib/sdk'
import { isEmptyList } from '../emptyList'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const SurveysPage = lazyPage(() => import('@/pages/Surveys'), 'SurveysPage')

export const surveysModule: ModuleDefinition = {
  key: 'surveys',
  icon: ClipboardList,
  iconName: 'clipboard-list',
  namespaces: ['surveys'],
  ready: true,
  ListPage: SurveysPage,
  /* "One survey" or "Several surveys" (F-103): short, so it sits on the details step. */
  setup: {
    wizardStep: 'details',
    /* Surveys are made by owner and admin. */
    defaultWhoCanPost: 'admins',
    defaultConfig: () => defaultSurveysConfig(),
    validate: () => null,
    errorsFromApi: (err) => surveysConfigApiErrors(err),
    Fields: SurveysSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({ ...(stored || {}), mode: config?.mode === 'single' ? 'single' : 'multi' }),
      fromSpace: (space) => surveysConfigOf(space.moduleConfig as Record<string, unknown> | null | undefined)
    }
  },
  /* Surveys have their own roles: nobody "posts" in the space. */
  posting: false,
  singleItem: { isEmpty: async (spaceId) => isEmptyList(await sdk.surveys.list({ spaceId, limit: 1 })) },
  workflow: { trigger: { block: 'surveys', icon: ListChecks, families: ['survey'] } }
}
